"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ENDPOINT_SAML = void 0;
var ENDPOINT_SAML = '/api/v1/auth/';
exports.ENDPOINT_SAML = ENDPOINT_SAML;